import { Color, RGB, RGBA } from '../types';

// opaque colors
export const black: Color = [0, 0, 0]; // #000000
export const creamYellow: Color = [250, 250, 168]; // #fafaa8
export const grey: Color = [200, 200, 200]; // #c8c8c8
export const greyWhite: Color = [238, 248, 250]; // #eef8fa
export const royalBlue: Color = [29, 52, 132, 255]; // #1D3484
export const periwinkle: Color = [85, 107, 187, 255]; // #556BBB
export const white: Color = [255, 255, 255]; // #ffffff
export const deepGrey: Color = [80, 80, 80]; // #505050
export const darkGrey: Color = [100, 100, 100]; // #646464
export const mediumGrey: Color = [160, 160, 160, 175]; // #a0a0a0
export const lightGrey: Color = [240, 240, 240]; // #f0f0f0
export const goldenYellow: RGB = [253, 213, 0]; // #fdd500

// RGBA black
export const blackRGBA0: Color = [0, 0, 0, 0]; // #00000000
export const blackRGBA38: Color = [0, 0, 0, 99]; // #00000061

// 50% transparent colors
export const whiteTransparent50: Color = [255, 255, 255, 127]; // #ffffff80
export const orangeTransparent50: Color = [222, 168, 90, 127]; // #dea85a80
export const skyBlueTransparent50: Color = [57, 150, 255, 127]; // #3996ff80
export const periwinkleTransparent50: Color = [152, 175, 255, 127]; // #98afff80

// other transparent colors
export const goldenYellowTransparent39: RGBA = [...goldenYellow, 100]; // #fdd50063
export const whiteTransparent60: RGBA = [255, 255, 255, 153]; // #ffffff99

// ogi color
export const darkTealTransparent60: RGBA = [12, 25, 26, 153]; // #0c191a
export const darkTealTransparent20: RGBA = [12, 25, 26, 51];

// ogi categorical colors
export const brightYellow: Color = [255, 217, 26];
export const electricGreen: Color = [98, 255, 0];
export const mintGreen: Color = [0, 230, 92];
export const dolphinBlue: Color = [0, 167, 204];
export const brightNavy: Color = [0, 6, 179];
export const grapePurple: Color = [115, 0, 153];
export const brightBlue: Color = [26, 64, 255];
export const lavender: Color = [157, 0, 255];
export const flamingoPink: Color = [230, 0, 138];
export const tomatoRed: Color = [204, 34, 0];
export const grossYellow: Color = [179, 170, 0];
export const grassGreen: Color = [41, 153, 0];

export const categoricalColors = {
    brightYellow,
    electricGreen,

    dolphinBlue,
    brightNavy,
    grapePurple,
    brightBlue,
    lavender,
    flamingoPink,
    tomatoRed,
    grossYellow,
    grassGreen,
    mintGreen
};
